//export const APP_API_URL = 'http://localhost:3001'
export const APP_API_URL = 'https://afn2mne-api.laoitconsult.com'